import { QueryClient } from '@tanstack/react-query';

const defaultQueryConfig = { staleTime: 60000 };

export const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig }
});

export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    CODE_COLLECTION: 'code_collection',
    CONCEPT_COLLECTION: 'concept_collection',
    CRITERIAS: 'criterias',
    CRITERIA: 'criteria',
    CRITERIA_DUPLICATE: 'criteria_duplicate',
    CRITERIA_EXPORT: 'criteria_export',
    CRITERIA_IMPORT: 'criteria_import',
    CRITERIA_METADATA: 'criteria_metadata',
    RESOURCE: 'resource',
    CRITERIA_RESOURCES_ARR: 'criteria-resources-arr',
    CRITERIA_PREDICATE_METADATA: 'criteria-predicate-metadata',
    CRITERIA_PREDICATE: 'criteria-predicate',
    CRITERIA_PREDICATE_PART: 'criteria-predicate-part',
    CRITERIA_PREDICATE_PART_METADATA: 'criteria-predicate-part-metadata',
    CRITERIA_PREDICATE_PART_RELS_METADATA: 'criteria-predicate-part-rels-metadata'
};

export const MUTATION_KEYS = {};
